import React, { useState } from 'react';
interface TabsProps {
  tabs: {
    id: string;
    name: string;
    content: React.ReactNode;
  }[];
  defaultTab?: string;
}
export function Tabs({
  tabs,
  defaultTab
}: TabsProps) {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0].id);
  return <div data-id="element-1526">
      <div className="border-b border-gray-200" data-id="element-1527">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs" data-id="element-1528">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`
                whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm transition-colors
                ${activeTab === tab.id ? 'border-[#7B68EE] text-[#7B68EE]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
              `} aria-current={activeTab === tab.id ? 'page' : undefined} data-id="element-1529">
              {tab.name}
            </button>)}
        </nav>
      </div>
      <div className="mt-5" data-id="element-1530">
        {tabs.find(tab => tab.id === activeTab)?.content}
      </div>
    </div>;
}